import React, { useState } from 'react'
import BreadCrumb from '../../../Components/Utils/Breadcrumbs';
import SearchBar from '../../../Components/Utils/SearchBar';
import { CreateButton } from '../../../Components/Utils/Buttons';
import { Link, useParams } from 'react-router-dom';
import DataTable from '../../../Components/Layouts/DataTable';
import Edit from '../../../Components/Icons/Edit';
import View from '../../../Components/Icons/View';
import Delete from '../../../Components/Icons/Delete';
import AxiosInstance from '../../../Services/axiosCommon';

function JournalEntryIndex() {
  const {officeId} =useParams();
  const [data, setData] = useState([]);
  async function getCash() {
    const params = {
      page:1,
      per_page:20,
    };
    await AxiosInstance
      .get(`/journalEntry/`,{ params })
      .then(async (res) => {
        console.log(res.data.data.cashDetails)
        res?.data?.data && setData(res?.data?.data.journalEntryDetails
          );
        // setTotalSubs(res.data?.totalRecords);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  let headers = [
    {
      label: <span>Date</span>,
      width: "w-[7%]",
    },
    {
      label: <span>Account TYpe</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Category</span>,
      width: "w-[15%]",
    },
    {
      label: <span>Description</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Amount</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Comments</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Action</span>,
      width: "w-[10%]",
    },
  ];
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full h-[46px]  flex justify-between ">
        <BreadCrumb
          items={[
            { title: <p className=" text-[12px] ">Test</p> },
            { title: <p className=" text-[12px] ">Journal Entry</p> },
          ]}
        />
        <div className=" flex gap-2">
          <SearchBar />
          <CreateButton label="Import" />
          <Link to="/main/journal-entry/${officeId}/create">
            <CreateButton label="Add" />
          </Link>
        </div>
      </div>

      <DataTable
        headers={headers}
        total={100}
        pageIndex={1}
        setPageIndex={() => {}}
        dataCount={20}
        setDataCount={() => {}}
      >
        {data.length > 0 ? (
          data.map((item, i) => {
            return (
              <tr
                className=" p-1 hover:scale-y-105 rounded-l-md hover:shadow-md"
                key={i}
              >
                <td className="w-[7%] py-3 my-6 text-center bg-white rounded-l-md ">
                  {item?.journalEntryId || "#"}
                </td>
                <td className="w-[10%] p-2 text-center bg-white">
                  {item?.date || ""}
                </td>
                <td className="w-[15%] p-2 text-center bg-white">
                  {item?.accountType || "-"}
                </td>
                <td className="w-[10%] p-2 text-center bg-white">
                  {item?.category || ""}
                </td>
                {/* <td className="w-[15%] p-2 text-right ">test</td> */}
                <td className="w-[10%] p-2  text-right bg-white">
                  {item?.description || 0}
                </td>
                <td className="w-[10%] p-2  text-right bg-white">
                  {item?.amount || 0}
                </td>
                <td className="w-[10%] p-2  text-center bg-white">
                  {item?.comments || 0}
                </td>
                {/* <td className="w-[10%] p-2  text-center bg-white">
                  {item?.colSeven || 0}
                </td> */}
                <td className="w-[10%] p-2 text-center bg-white rounded-r-md">
                  <div className=" w-full flex justify-center items-center gap-2">
                    <Link to={`/main/journal-entry/${officeId}/view/${item?.journalEntryId}`}>
                      <View />
                    </Link>
                    <Link to={`/main/journal-entry/${officeId}/edit/${item?.journalEntryId}`}>
                      <Edit />
                    </Link>
                    <Link>
                      <Delete />
                    </Link>
                  </div>
                </td>
              </tr>
            );
          })
        ) : (
          <tr className=" text-center my-2 font-semibold text-sm">
            <div className=" w-full h-[calc(100vh-240px)] rounded-md flex justify-center items-center bg-slate-300">
            No Data Found
            </div>
          </tr>
        )}
      </DataTable>
    </div>
  );
}

export default JournalEntryIndex;